import React from "react"
import g from "glamorous"
import breakpoints from "../components/breakpoints.jsx"
import WorkListItem from "./work-list-item.js"

const ProductList = g.ul({
    listStyleType: `none`,
    marginLeft: `0`,
})

class WorkList extends React.Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <ProductList>
                {this.props.products.edges.map(({node}) => 
                    <WorkListItem
                        key={node.id}
                        photo={node.photos[0].file.url}
                        description={node.photos[0].description}
                        title={node.title}
                        slug={node.fields.slug}
                    >
                    </WorkListItem>
                )}
            </ProductList>
        )
    }
}

export default WorkList


// WEBPACK FOOTER //
// ./src/components/product-list.jsx